import {
    type GetProfileResponseType
} from "./type";
import {
    request
} from "../request";

const GetProfile = async (): Promise<GetProfileResponseType> => {
    return await request<GetProfileResponseType>("/auth/profile", {
        method: "GET"
    });
};

export default GetProfile;
